import { LOGS_STORAGE_NAME } from '../constants'

const ERROR = 'ERROR'
const INFO = 'INFO'
const WARN = 'WARN'

const read = () => localStorage ? JSON.parse(localStorage?.getItem(LOGS_STORAGE_NAME)) || [] : []

const write = logs => {
  if (localStorage) {
    try {
      localStorage.setItem(LOGS_STORAGE_NAME, JSON.stringify(logs))
    } catch (err) {
      localStorage.removeItem(LOGS_STORAGE_NAME)
    }
  }
}

const getAllLogs = () => {
  const logs = read()
  return `${navigator.userAgent}\n\n${logs.map(logEntry => logEntry.log).join('\n')}`
}

const getValidLogs = logs => {
  const now = new Date()
  const EXPIRY_OFFSET = 1000 * 60 * 60 // 1 hour

  return logs.filter(log => log.timestamp + EXPIRY_OFFSET > now.getTime())
}

const add = (params, message) => {
  const now = new Date()
  const logs = read()
  const dateString = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`
  let log = `[${dateString}] ${message}`

  if (params) {
    try {
      const paramsString = JSON.stringify(params)
      log += ` ${paramsString}`
    } catch (err) {
      log += ` ${params}`
    }
  }

  logs.push({
    timestamp: now.getTime(),
    log
  })

  write(getValidLogs(logs))
}

const info = (params, msg) => {
  const message = `[${INFO}] ${msg}`

  add(params, message)
}

const error = (params, msg) => {
  const message = `[${ERROR}] ${msg}`

  add(params, message)
}

const warn = (params, msg) => {
  const message = `[${WARN}] ${msg}`

  add(params, message)
}

export default {
  getAllLogs,
  info,
  error,
  warn
}
